module.exports = __webpack_public_path__ + "static/end-1db31e4bf8fd88064515ecee9da1298c.png";